import dayjs from "dayjs";
import { FC, InputHTMLAttributes, useEffect, useRef, useState } from "react";
import CalendarCustom from "../calendar/CalendarCustom";

export const FormCalendarField: FC<
  InputHTMLAttributes<HTMLInputElement> & {
    label?: string;
    date?: Date;
    onChangeDate?: (date: Date) => void;
  }
> = ({ label, date, onChangeDate, ...props }) => {
  const [isCalendarVisible, setCalendarVisible] = useState(false);
  const calendarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target as Node)
      ) {
        setCalendarVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [calendarRef]);
  return (
    <label className="relative flex w-full flex-col">
      <span className="mb-2.5 text-sm font-medium leading-[22px] tracking-[-0.01em] text-[#232323]">
        {label}
      </span>
      <span className="calendar-input relative w-full">
        <input
          className="h-[50px] w-full rounded-[10px] border-[1px] border-solid border-[#DCDCDC] bg-[#FFFFFF] px-[12px] py-0"
          {...props}
          value={date ? dayjs(date).format("DD/MM/YYYY") : ""} // Format the date as needed
          onFocus={() => setCalendarVisible(true)}
        />
      </span>

      {isCalendarVisible && (
        <div ref={calendarRef} className="absolute inset-0 z-10 mt-[5.625rem]">
          <CalendarCustom
            disablePastDates={true}
            defaultDate={date}
            onDayClick={(date: Date) => {
              onChangeDate?.(date);
              setTimeout(() => {
                setCalendarVisible(false); // Hide calendar after selecting a date
              }, 100); // Allow time for the input to update before hiding the calendar
            }}
          />
        </div>
      )}
    </label>
  );
};
